export enum SyncStatusEnum {
  pending,
  syncing,
  synced,
  skipped,
  error,
  notFound,
}
